import AllGrowsScreen from './AllGrowsScreen';

export default AllGrowsScreen;